import './Home.css';
import astro from './Astrovdo.mp4';
import img_about from './Astroabout.png';
import img_about2 from './Astroabout2.png';
import hole from './hole.png';
import proj1 from './img_projeto1.jpg';
import proj2 from './img_projeto2.jpg';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

function Home() {
  const section = {
      sobre: useRef(null),
      projetos: useRef(null)
    };

  const handleClick = (seção) => {section[seção].current.scrollIntoView({behavior: 'smooth'});};

  return (

    <div className="App">
      <div className='show'>
        <header className='space_header'>
          <nav>
            <button onClick={() => handleClick('sobre')}className='botao_esp' >Sobre nós</button>
            <Link to="/formulario" className='botao_espx'>Inscreva-se</Link>
            <button onClick={() => handleClick('projetos')} className='botao_esp'>Projetos</button>
          </nav>
        </header>
        <video src={astro} autoPlay muted loop className='video_bkg'></video>
      </div>

      <section ref={section.sobre} className="astro-section">
        <div className='div_about'>
          <img src={img_about} alt="imagem sobre nós" className='about_img'/>
          <p className='about_txt'>Somos a Astroproject, a empresa que promete te levar para o espaço, mas não garante que você volte. Fundada por um grupo de ex-funcionários demitidos da NASA por "ideias muito ousadas", nossa missão é colonizar planetas inóspitos com voluntários (você).</p>
          <img src={img_about2} alt="imagem sobre nós 2" className='about_img' />
          <p className='about_txt2'>Por Que Escolher a Astroproject?</p>
          <div className='about_list_div'>
              <div className='ri'>
                <h2>Treinamento Rígido</h2>
                  <p> • Aulas ministradas por um youtuber que estudou astronomia por 3 dias.</p>
                  <p> • Simulador de gravidade zero (sua cadeira gaymer amarrada num elástico).</p>
              </div><div className='ri'>
                <h2>Segurança Forte</h2>
                  <p> • Nossos foguetes têm 50% de chance de decolar (os outros 50% viram pirotecnia possivelmente autorizada).</p>
                  <p> • kit de sobrevivência incluso: um pacote de biscoito de polvilho e um apito.</p>
              </div><div className='ri'>
                <h2>Privacidade Garantida</h2>
                  <p> • Com 110% de certeza seus dados não serão vendidos aos marcianos a 10 Anos luz de você</p>
              </div><div className='ri'>
                <h2>Custo-Benefício</h2>
                  <p> • É quase de graça, custa apenas a sua aposentadoria (ou a alma)</p>
              </div>
      
          </div>
        </div>
      </section>
      <section ref={section.projetos} className="astro-section">
        <div className='projects'>
          <h1 className='projects_title'>Projetos: </h1>
          <img src={hole} alt="imagem projetos" className='img_projects'/>
          <img src={proj1} alt="imagem projeto 1" className='img_projects1' />
          <img src={proj2} alt="imagem projeto 2" className='img_projects2'/>
          <p className='txt_proj1'> Esse é nosso novo sistema de propulsão ultramordeno desenvolvido para o seu maior conforto</p>
          <p className='txt_proj2'> Desenvolvemos um novo pet geneticamente modificado e potencialmente radioativo para te acompanhar!! </p>
        </div>
      </section>

        <footer>
          <h1 className='tit_footer'>Dados para contato:</h1>
          <div className='div_footer'>
            <div>
              <p>Espace-mail:</p>
              <p>Id-numérico:</p>
              <p>Coodenadas:</p>
              <p>Webgram:</p>
            </div>
            <div>
              <p>naoContacte@issomesmo.com</p>
              <p>71 6666666666 (sim, somos baianos)</p>
              <p>50°00'36.30″N, 110°06'46.82″W</p>
              <p>@Astroproject_ofical_</p>
            </div>
          </div>
          <p className='texto_final'>Astroproject™ – "Tornando a ficção científica em processos judiciais desde 2025." 🚀💀</p>
        </footer>
      
    </div>
  );
}

export default Home;